exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".empty_from_OtherActivities-css_19J {\r\n  font-weight: 400;\r\n  font-size: 0.775em;\r\n  color: #A0A3A3;\r\n  padding: 24px 32px;\r\n  padding-top: 0;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"empty": "empty_from_OtherActivities-css_19J"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??ref--3-2!./app/web/src/routes/sales/Lead/OtherActivities/OtherActivities.css
// module id = ./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/OtherActivities/OtherActivities.css
// module chunks = 0